class DeliverySaverEligibilityNotificationsController {
    constructor(settings, shopperService) {
        this.settings = settings;
        this.shopperService = shopperService;
    }

    $onInit() {
        if (this.shopperService.isBusinessShopper()) {
            this.seniorPlansNotEligibleTitle = this.settings.deliverySaver.seniorPlansNotEligibleForB2bTitle;
        } else {
            this.seniorPlansNotEligibleTitle = this.settings.deliverySaver.seniorPlansNotEligibleForPersonalTitle;
        }
    }
}

DeliverySaverEligibilityNotificationsController.$inject = ['Settings', 'ShopperService'];

const DeliverySaverEligibilityNotificationsComponentDefinition = {
    controller: DeliverySaverEligibilityNotificationsController,
    template: require('./delivery-saver-eligibility-notifications.component.html').trim(),
    bindings: {
        hasLoadPlansError: '<',
        hasActiveDeliveryPass: '<',
        hasActiveDeliverySaver: '<',
        hasSuspendedDeliverySaver: '<',
        dateEligibleForDeliverySaver: '<',
        showPersonalPlansNotEligible: '<',
        showBusinessPlansNotEligible: '<',
        showSeniorPlansEligible: '<',
        showSeniorPlansNotEligible: '<',
    },
};

module.exports = {
    DeliverySaverEligibilityNotificationsController,
    DeliverySaverEligibilityNotificationsComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/eligibilitynotifications/delivery-saver-eligibility-notifications.component.js